<template>
  <context-page :title="$t('sidebar.dashboard')" :showLoader="loading">
    <v-container fluid class="ma-0 pa-0">
      <v-card tile>
        <v-card-title><h1 class="title">{{this.$t('dashboard.text')+', '+this.username}}</h1></v-card-title>
        <v-card-text v-if="summary">
          <v-alert color=teal text>
            <v-row no-gutters>
              <span class="title teal--text">Извештај о пријавама</span>
            </v-row>
          <v-divider class="my-4 teal" style="opacity: 0.22"></v-divider>
          <v-row no-gutters>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Време</p>
              <p class="title grey--text mb-1">{{formatDate(summary.reportTimestamp)}}</p>
            </v-col>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Укупно пријава</p>
              <p class="title grey--text mb-1">{{summary.registrations}}</p>
            </v-col>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Валидних пријава</p>
              <p class="title grey--text mb-1">{{summary.validRegistrations}}</p>
            </v-col>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Укупно захтева</p>
              <p class="title grey--text mb-1">{{summary.validBeneficiaries}}</p>
            </v-col>
          </v-row>
          </v-alert>
          <v-alert color=info text>
            <v-row no-gutters>
              <span class="title pending--text">Извештај о пријавама заокружен на 30 минута</span>
            </v-row>
          <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
          <v-row no-gutters>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Време</p>
              <p class="title grey--text mb-1">{{formatDate(summary.roundedReportTimestamp)}}</p>
            </v-col>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Укупно пријава</p>
              <p class="title grey--text mb-1">{{summary.roundedRegistrations}}</p>
            </v-col>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Валидних пријава</p>
              <p class="title grey--text mb-1">{{summary.roundedValidRegistrations}}</p>
            </v-col>
            <v-col cols=6 lg=3 xl=3>
              <p class="font-weigh-bold black--text mb-0">Укупно захтева</p>
              <p class="title grey--text mb-1">{{summary.roundedValidBeneficiaries}}</p>
            </v-col>
          </v-row>
          </v-alert>
          <v-alert color=info text>
            <v-row no-gutters>
              <v-col cols=6 lg=3 xl=3>
                <p class="font-weigh-bold black--text mb-0">Доступно за плаћање</p>
                <p class="title grey--text mb-1">{{summary.acquiredAccountRegistrations}}</p>
              </v-col>
              <v-col cols=6 lg=3 xl=3>
                <p class="font-weigh-bold black--text mb-0">Доступно за плаћање (деца)</p>
                <p class="title grey--text mb-1">{{summary.acquiredAccountBeneficiaries}}</p>
              </v-col>
              <v-col cols=6 lg=3 xl=3>
                <p class="font-weigh-bold black--text mb-0">Чека на рачун</p>
                <p class="title grey--text mb-1">{{summary.pendingAccountRegistrations}}</p>
              </v-col>
              <v-col cols=6 lg=3 xl=3>
                <p class="font-weigh-bold black--text mb-0">Чека на рачун (деца)</p>
                <p class="title grey--text mb-1">{{summary.pendingAccountBeneficiaries}}</p>
              </v-col>
            </v-row>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="#429a86" dark tile class="text-none body-2 mr-1" @click="retrieveSummary">Статистика</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </context-page>
</template>
<script>
import ContextPage from '@/components/context-page/ContextPage'
import { getUserName } from '@/router/auth.js'
import { EventBus } from '@/router/bus'
import Vue from 'vue'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      loading: false,
      errorCodeSource: 'apiStatusCodes.',
      username: '',
      summary: null
    }
  },
  created () {
    this.username = getUserName()
    EventBus.$on('logged-in', () => {
      this.username = getUserName()
    })
    this.logConsole('Dashboard created')
  },
  methods: {
    retrieveSummary () {
      this.loading = true
      // add api get request to roles and groups, localRoles and groups are muck for now
      this.$http.get(Vue.$apiConfig.subsidySummaryGet).then(
        response => {
          this.logConsole(response)
          this.summary = response.data.payload
          this.loading = false
        },
        error => {
          this.formatErrorResponse(error)
          this.logConsole(error)
          this.loading = false
        }
      )
    }
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
  h1{
    text-align: center;
  }
</style>
